import { HttpError } from "@/dashboard/lib/api/errors";

/**
 * React Query retry predicate: retry transient failures (5xx, network), but NOT
 * deterministic 4xx client errors. A 4xx won't succeed on retry, and for the live
 * audience source (reach/preview/options) a retried `PestPacLiveWindowTooLargeError`
 * re-runs an expensive serviceOrders fetch+bisect on the shared PestPac rate budget.
 */
export function retryNonClientError(failureCount: number, error: unknown): boolean {
  if (error instanceof HttpError && error.status >= 400 && error.status < 500) {
    return false;
  }
  // Match the app-wide default of 1 retry for transient failures — do NOT raise it
  // (these live calls are 20-42s each; an extra retry triples a persistent-5xx blast
  // radius on the shared PestPac budget).
  return failureCount < 1;
}

/** Retry a temporary-busy response once without repeating slow 500 queries. */
export function retryTemporaryBusyOnce(failureCount: number, error: unknown): boolean {
  return failureCount < 1 && error instanceof HttpError && error.status === 503;
}
